import React, { useState, useEffect } from 'react';

const tips = [
  "<b>68%</b> rate cover letters as important when deciding whether to invite an applicant for an interview — 1 in 4 say that cover letters are very important.",
  "Among companies who don't require a cover letter, <b>73%</b> frequently or always read them anyway.",
  "<b>55%</b> of medium-sized companies and <b>65%</b> of fast-growing startups demand cover letters.",
  "<b>78%</b> of recruiters prefer applicants to submit a cover letter (GetCoverLetter, 2020).",
  "<b>87%</b> of hiring managers read cover letters (ResumeGo, 2020).",
  "<b>74%</b> of hiring managers read cover letters when the job posting requires them (ResumeLab, 2019)."
];

interface ProgressBarProps {
  progress: number;
  isGenerating: boolean;
}

export function ProgressBar({ progress, isGenerating }: ProgressBarProps) {
  const [currentTip, setCurrentTip] = useState(0);
  const [isVisible, setIsVisible] = useState(true);

  useEffect(() => {
    if (progress > 0 && isGenerating) {
      const interval = setInterval(() => {
        setIsVisible(false);
        setTimeout(() => {
          setCurrentTip((prev) => (prev + 1) % tips.length);
          setIsVisible(true);
        }, 500);
      }, 4000);

      return () => clearInterval(interval);
    }
  }, [progress, isGenerating]);

  return (
    <div className="space-y-4">
      <div className="w-full h-2 bg-gray-200 rounded-full overflow-hidden">
        <div 
          className="h-full bg-blue-600 transition-all duration-500 ease-out"
          style={{ 
            width: `${progress}%`,
            transition: 'width 0.5s ease-out'
          }}
        />
      </div>
      {isGenerating && (
        <div className={`transition-opacity duration-500 ${isVisible ? 'opacity-100' : 'opacity-0'}`}>
          <p 
            className="text-sm text-gray-600"
            dangerouslySetInnerHTML={{ 
              __html: tips[currentTip]
            }}
          />
        </div>
      )}
      {!isGenerating && progress > 0 && (
        <p className="text-sm text-gray-600">
          Processing your file...
        </p>
      )}
    </div>
  );
}